<template>
  <div v-if="customIsVisible" :class="[backgroundColor, bottomMargin, verticalPadding]" class="image-block">
    <div class="mx-auto w-full max-w-screen-2xl px-5 md:px-12 flex flex-row justify-center">
      <img :src="model.image" :alt="model.alttext" class="rounded-lg" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  model: {
    image: string;
    alttext: string;
  };

  background?: string;
  settings: any;

  // Innovadis custom: Use custom visibility setting
  customIsVisible: boolean;

  // Innovadis custom: Use custom layout settings
  backgroundColor: string;
  bottomMargin: string;
  verticalPadding: string;
}>();
</script>
